<template>
  <q-chip
    clickable
    square
    :color="color"
    :text-color="textColor"
    :label="payment.state ? $_.startCase(payment.state) : '<unknown>'"
  />
</template>

<script>

export default {
  name: 'OrderStateCell',
  props: {
    props: {
      type: Object,
      required: true
    }
  },
  computed: {
    payment () {
      return this.props.row
    },
    color () {
      if (this.payment.state === 'completed') {
        return 'indigo-2'
      } else if (this.payment.state === 'voided') {
        return 'negative'
      } else if (this.payment.state === 'canceled') {
        return 'negative'
      } else if (this.payment.state === 'disputed') {
        return 'warning'
      } else if (this.payment.state === 'lost_dispute') {
        return 'red-3'
      } else {
        return null
      }
    },
    textColor () {
      if (this.payment.state === 'completed') {
        return 'dark'
      } else if (this.payment.state === 'voided') {
        return 'white'
      } else if (this.payment.state === 'canceled') {
        return 'white'
      } else if (this.payment.state === 'lost_dispute') {
        return 'white'
      } else if (this.payment.state === 'disputed') {
        return 'white'
      } else if (this.payment.state === 'draft') {
        return 'grey-6'
      } else {
        return 'dark'
      }
    }
  }
}

</script>
